/**
 * Color constants for property boundary and map pin fills organized by property type (investment, lease, contract-managed, direct-operations, etc.).
 */
export const propertyColors = {
  investment: 'rgba(250, 128, 114,1)',
  investmentHistorical: 'maroon', //salmon
  investmentCompleted: 'rgba(34, 197, 94, 0.98)',
  lease: 'rgba(204,115,255,.75)',
  contractManaged: '#40E0D0',
  pri: 'rgba(228 84 160,1)',
  directOperations: '#5e83ff',
  other: '#40E0D0',
  /**
   * Gray treatment for the explicit `MgmtType` `Unknown` classification
   * (null/blank/unexpected layer-14 boundary values). Must be visibly
   * distinct from every valid `MgmtType` category, including
   * `contractManaged`.
   */
  unknownMgmtType: '#9CA3AF'
};

/**
 * Color constants for land use classification layer fills — shades of gray/green/purple for irrigated tillable, dryland tillable, pasture, and other classifications.
 */
export const landUseColors = {
  irrigatedTillable: 'rgba(158, 168, 219, 0.75)',
  nonTillable: 'rgba(215, 208, 124, 0.75)',
  dryLandTillable: 'rgba(108, 156, 121, 0.75)',
  pasture: 'rgba(183, 154, 195, 0.75)',
  governmentContract: 'rgba(245, 183, 116, 0.75)'
};

